// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","main":"Logo_main__kCFcl","icon":"Logo_icon__ndBv7","link":"Logo_link__AoPyS"};